// import { useEffect, useRef, useState } from "react";
// import justifiedLayout from "justified-layout";
// import g1 from "../../Assets/Images/g1.png";
// import g2 from "../../Assets/Images/g2.png";
// import g3 from "../../Assets/Images/g3.png";
// import g4 from "../../Assets/Images/g4.png";
// import g5 from "../../Assets/Images/g5.png";
// import g6 from "../../Assets/Images/g6.png";
// import g7 from "../../Assets/Images/g7.png";

// const imageSources = [g1, g2, g3, g4, g5, g6, g7];

// function GalleryInner() {
//     const containerRef = useRef(null);
//     const [aspectRatios, setAspectRatios] = useState([]);
//     const [containerWidth, setContainerWidth] = useState(0);

//     // Load image aspect ratios once
//     useEffect(() => {
//         const loadImages = async () => {
//             const ratios = await Promise.all(
//                 imageSources.map(src =>
//                     new Promise(resolve => {
//                         const img = new Image();
//                         img.src = src;
//                         img.onload = () => resolve(img.naturalWidth / img.naturalHeight);
//                     })
//                 )
//             );
//             setAspectRatios(ratios);
//         };
//         loadImages();
//     }, []);

//     // Update container width on mount and resize
//     useEffect(() => {
//         const updateWidth = () => {
//             if (containerRef.current) {
//                 setContainerWidth(containerRef.current.clientWidth);
//             }
//         };

//         updateWidth(); // Initial call
//         window.addEventListener("resize", updateWidth);

//         return () => window.removeEventListener("resize", updateWidth);
//     }, []);

//     // Layout calculation when aspectRatios or width changes
//     useEffect(() => {
//         if (!aspectRatios.length || !containerRef.current || !containerWidth) return;

//         const container = containerRef.current;

//         const layout = justifiedLayout(aspectRatios, {
//             containerWidth: containerWidth,
//             targetRowHeight: 350,
//             boxSpacing: 10,
//         });

//         container.style.position = "relative";
//         container.style.height = `${layout.containerHeight}px`;

//         Array.from(container.children).forEach((img, index) => {
//             const box = layout.boxes[index];
//             img.style.position = "absolute";
//             img.style.width = `${box.width}px`;
//             img.style.height = `${box.height}px`;
//             img.style.transform = `translate(${box.left}px, ${box.top}px)`;
//         });
//     }, [aspectRatios, containerWidth]);

//     return (
//         <div className="gallery">
//                 <div className="bg-dark text-danger text-center d-flex flex-column align-items-center justify-content-center gallery-hero-sect">
//                     <h2>Visicon</h2>
//                 </div>

//             <section className="">
//                 <div className="container-fluid mt-5">
//                     <div ref={containerRef} className="gallery-container">
//                         {imageSources.map((src, index) => (
//                             <div key={index} className="image-wrapper">
//                                 <img
//                                     src={src}
//                                     alt={`Gallery ${index + 1}`}
//                                     className="gallery-image"
//                                 />
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </section>
//         </div>
//     );
// }

// export default GalleryInner;


import { useEffect, useRef, useState } from "react";
import justifiedLayout from "justified-layout";
import axios from "../../axios";
import { useParams } from "react-router-dom";

function GalleryInner() {
    const { eventId } = useParams();
    const containerRef = useRef(null);
    const [images, setImages] = useState([]);
    const [aspectRatios, setAspectRatios] = useState([]);
    const [containerWidth, setContainerWidth] = useState(0);
    const [eventTitle, setEventTitle] = useState("");

    // Fetch images by eventId
    useEffect(() => {
        axios.get("/galleries")
            .then((res) => {
                const filtered = res.data.filter(g => String(g.event_id) === eventId);
                setImages(filtered);
                if (filtered.length > 0) {
                    setEventTitle(filtered[0].event?.title || "Untitled Event");
                }
            })
            .catch((err) => {
                console.error("Failed to fetch images", err);
            });
    }, [eventId]);

    // Load aspect ratios after images are fetched
    useEffect(() => {
        const loadRatios = async () => {
            const ratios = await Promise.all(
                images.map(img =>
                    new Promise(resolve => {
                        const image = new Image();
                        image.src = img.image_url;
                        image.onload = () => resolve(image.naturalWidth / image.naturalHeight);
                    })
                )
            );
            setAspectRatios(ratios);
        };

        if (images.length > 0) loadRatios();
    }, [images]);

    // Update container width
    useEffect(() => {
        const updateWidth = () => {
            if (containerRef.current) {
                setContainerWidth(containerRef.current.clientWidth);
            }
        };

        updateWidth();
        window.addEventListener("resize", updateWidth);
        return () => window.removeEventListener("resize", updateWidth);
    }, []);

    // Layout images
    useEffect(() => {
        if (!aspectRatios.length || !containerWidth || !containerRef.current) return;

        const layout = justifiedLayout(aspectRatios, {
            containerWidth,
            targetRowHeight: 350,
            boxSpacing: 10,
        });

        const container = containerRef.current;
        container.style.position = "relative";
        container.style.height = `${layout.containerHeight}px`;

        Array.from(container.children).forEach((imgWrapper, index) => {
            const box = layout.boxes[index];
            imgWrapper.style.position = "absolute";
            imgWrapper.style.width = `${box.width}px`;
            imgWrapper.style.height = `${box.height}px`;
            imgWrapper.style.transform = `translate(${box.left}px, ${box.top}px)`;
        });
    }, [aspectRatios, containerWidth]);

    return (
        <div className="gallery">
            <div className="bg-dark text-danger text-center d-flex flex-column align-items-center justify-content-center gallery-hero-sect">
                <h2>{eventTitle}</h2>
            </div>

            <section>
                <div className="container-fluid mt-5">
                    <div ref={containerRef} className="gallery-container">
                        {images.map((img, index) => (
                            <div key={index} className="image-wrapper">
                                <img
                                    src={img.image_url}
                                    alt={`Gallery ${index + 1}`}
                                    className="gallery-image"
                                    loading="lazy"
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}

export default GalleryInner;
